import React,{useState} from 'react';

///Styles
import { FaCog,FaSortUp,FaSortDown } from 'react-icons/fa';
import {ContainerLoading ,Container} from './styles';

///Components
import { SpaceLoader } from '../../../loaders/spaceLoader';


///Services
import moment from 'moment';


export function Table({loading,datasTable,handleIsOrder,setIsOpen,setBusinessData}){

    const [selected,setSelected] = useState('');
    const [isDesc,setIsDesc] = useState(false);

    const [headers] = useState([
        {id: 1, title: 'ID', value: 'idBusiness'},
        {id: 2, title: 'ID Customizado', value: 'idCustomized'},
        {id: 3, title: 'Empresa', value: 'name'},
        {id: 4, title: 'Cidade', value: 'city'},
        {id: 5, title: 'UF', value: 'state'},
        {id: 6, title: 'Bairro', value: 'neighborhood'},
        {id: 7, title: 'CNPJ', value: 'cnpj'},
        {id: 8, title: 'Data Sincronização', value: 'lastSync'}
    ])

    function openModal(data){
        //console.log(data)
        setIsOpen()
        setBusinessData(data)
    }

    function orderTable(item){
        handleIsOrder(item);
        setSelected(item);
        setIsDesc(!isDesc);
    }

    if(loading){
        return(
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <table>
                <thead>
                    <tr>
                        {
                            headers.map((item,index) => {
                                return (
                                    <th 
                                        key={index}
                                        onClick={() => item.value === 'idCustomized' ? {} : orderTable(item.value)}
                                    >
                                        <div>
                                        {item.title} {selected === item.value ? (
                                            isDesc ? <FaSortUp/> : <FaSortDown/>
                                        ) : ''}
                                        </div>
                                    </th>
                                )
                            })
                        }
                        <th></th>
                    </tr>
                </thead>
        
                <tbody>
                    
                    {
                        datasTable.map((data) => {
                            return(
                                <tr key={data.idBusiness}>
                                    <td>{data.idBusiness}</td>
                                    <td>{data.idCustomized !== null || data.idCustomized !== undefined ? data.idCustomized : ''}</td>
                                    <td>{data.name}</td>
                                    <td>{data.city}</td>
                                    <td>{data.state}</td>
                                    <td>{data.neighborhood}</td>
                                    <td>{data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}</td>
                                    <td>{moment(data.lastSync?.slice(0, 16)).format('DD/MM/YYYY HH:mm')}</td>
                                    <td>
                                        <button className='button' onClick={() => openModal(data)}><FaCog/></button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </Container>
    )
}